import { create } from "zustand";

type UiStore = {
  enabledCount: number;
  mobileSearch: boolean;
  actions: {
    enableSearch: () => void;
    disableSearch: () => void;
    enableMobileSearch: () => void;
    disableMobileSearch: () => void;
  };
};

const useUiStore = create<UiStore>()((set, get) => ({
  mobileSearch: false,
  enabledCount: 1,
  actions: {
    enableSearch: () => set({ enabledCount: get().enabledCount + 1 }),
    disableSearch: () => set({ enabledCount: get().enabledCount - 1 }),
    enableMobileSearch: () => set({ mobileSearch: true }),
    disableMobileSearch: () => set({ mobileSearch: false }),
  },
}));

export const useMobileSearchEnabled = () => useUiStore((x) => x.mobileSearch);
export const useSearchEnabled = () => useUiStore((x) => x.enabledCount != 0);
export const useUiActions = () => useUiStore((x) => x.actions);
